/**
 * Team Block.
 * 
 */

/**
 * Desktop: Nothing.
 * Mobile: Set width CSS on team chip blade based on width.
 * NB. Assumes the only inline CSS assigned to blade is "width:min-content".
 */

let 
	$window = $(window),
	prevWindowW = $window.width(),
	currWindowW = prevWindowW,
	$blades = $('.team-chip__blade'),
	$chips = $('.team-chip__photo'),
	breakpoint = 1024;

function setBladeWidths() {
	// console.log("TEAM: setBladeWidths()");

	$blades.each(function() {
		// Get chip width (minus approx wedge width).
		var chip_w = $chips.first().outerWidth() - 24;
		// Remove inline CSS (width:min-content) before getting blade width.
		$(this).attr('style', '');
		// Get blade width.
		var blade_w = $(this).outerWidth();

		// If blade is wider than chip...
		if (blade_w >= chip_w) {
			// Set width:min-content.
			// $(this).css('width', 'min-content');
			// Set width:80%.
			$(this).css('width','80%');
			// Recursively set and test smaller blade widths.
			getBladeWidth($(this));
		// If blade is thinner than chip...
		} else {
			// Remove inline CSS from blade.
			// $(this).attr('style', '');
		}
	});
}

function getBladeWidth($my_blade) {
	// console.log("TEAM: getBladeWidth()");
	// Get chip width (minus approx wedge width).
	var chip_w = $chips.first().outerWidth() - 16;

	// Get blade w & h & total blade w...
	var blade_w = $my_blade.outerWidth();
	var blade_h = $my_blade.outerHeight();
	var blade_tri_w = blade_h / 3;
	var total_w = blade_w + blade_tri_w;

	var $my_name = $my_blade.find('.team-chip__name');

	// Set blade w to current w minus 10% (of chip w).
	var new_w = 'calc('+blade_w+'px - '+chip_w+'px/10)';
	$my_blade.css('width', new_w);
	var name_w = $my_name.outerWidth();

	// Compare resulting blade h to previous blade h...
	// If new h > old h, a line break was triggered and the blade w is too tight.
	// This means we should use the previous blade w, so set that.
	// if not, try again (call function recursively).

	var new_blade_w = $my_blade.outerWidth();
	var new_blade_h = $my_blade.outerHeight();
	// console.log("TEAM: getBladeWidth(): new_blade_h / blade_h : "+new_blade_h+" / "+blade_h);
	// console.log("TEAM: getBladeWidth(): new_w: "+new_w);
	if (new_blade_h > blade_h) {
		if (total_w < chip_w) {
			$my_blade.css('width', blade_w);
		}
	} else if (new_blade_w < name_w) {
		new_w = 'calc('+blade_w+'px + '+chip_w+'px/5)';
		$my_blade.css('width', new_w);
	} else {
		getBladeWidth($my_blade);
	}
}

function initResizeWatcher() {
	// console.log('TEAM: initResizeWatcher()');


	$window.on('resize', function() {
		// console.log('currWindowW: '+currWindowW);

		currWindowW = window.innerWidth;

		// Viewport crosses from mobile to desktop.
		if ((currWindowW >= breakpoint) && (prevWindowW < breakpoint)) {
			// console.log("Mobile to Desktop");
			// Remove inline CSS.
			$blades.attr('style', '');
		}

		// Viewport crosses from desktop to mobile.
		// if ((currWindowW < breakpoint) && (prevWindowW >= breakpoint)) {
		// }

		// Viewport is mobile.
		if (currWindowW < breakpoint) {
			// Set blade widths.
			setBladeWidths();
		}

		// Viewport is desktop.
		if (currWindowW >= breakpoint) {
			setBladeWidths();
		}

		prevWindowW = $window.width();
	});

// 	$window.on('resize', function() {
// 		console.log('currWindowW: '+currWindowW);

// 		currWindowW = $window.width();

// 		// Viewport crosses from mobile to desktop.
// 		if ((currWindowW >= breakpoint) && (prevWindowW < breakpoint)) {
// 			console.log("Mobile to Desktop");
// 			// Remove inline CSS.
// 			$blades.attr('style', '');
// 		}

// 		// Viewport width crosses from desktop to mobile.
// 		// if ((currWindowW < breakpoint) && (prevWindowW >= breakpoint)) {
// 		// }

// 		// Viewport is mobile.
// 		if (currWindowW < breakpoint) {
// 			// Set blade widths.
// 			setBladeWidths();
// 		}

// 		prevWindowW = $window.width();
// 	});
}

exports.init = function () {
	// console.log('TEAM: exports.init');
    // Run init methods...

	$(function() {
		setBladeWidths();
		initResizeWatcher();	
	});
};